/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const XRayIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#BDC8D4',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="12"
        fill="url(#paint0_radial_16228_116835)"
      />
      <rect width="24" height="24" rx="12" fill={color} />
      <path
        d="M12 9C10.3458 9 9 10.3458 9 12C9 13.6542 10.3458 15 12 15C12.5275 15 13.0463 14.8612 13.5004 14.5985L13.125 13.9492C12.7848 14.146 12.3957 14.25 12 14.25C10.7593 14.25 9.75 13.2407 9.75 12C9.75 10.7593 10.7593 9.75 12 9.75C13.2407 9.75 14.25 10.7593 14.25 12V12.3267C14.25 12.572 14.0924 12.75 13.875 12.75C13.6683 12.75 13.5 12.5817 13.5 12.375V10.875H12.9816C12.7178 10.6445 12.377 10.5 12 10.5C11.1729 10.5 10.5 11.1729 10.5 12C10.5 12.8271 11.1729 13.5 12 13.5C12.3939 13.5 12.75 13.3443 13.0179 13.0951C13.2244 13.3405 13.5299 13.5 13.875 13.5C14.5058 13.5 15 12.9846 15 12.3267V12C15 10.3458 13.6542 9 12 9ZM12 12.75C11.5864 12.75 11.25 12.4136 11.25 12C11.25 11.5864 11.5864 11.25 12 11.25C12.4136 11.25 12.75 11.5864 12.75 12C12.75 12.4136 12.4136 12.75 12 12.75Z"
        fill="white"
      />
      <g clipPath="url(#clip0_16228_116835)">
        <path
          d="M17.6023 7.89844V9.54844C17.6023 9.61474 17.576 9.67833 17.5291 9.72521C17.4822 9.7721 17.4186 9.79844 17.3523 9.79844H16.8523C16.786 9.79844 16.7225 9.7721 16.6756 9.72521C16.6287 9.67833 16.6023 9.61474 16.6023 9.54844V7.89844C16.6023 7.76583 16.5497 7.63865 16.4559 7.54488C16.3621 7.45112 16.235 7.39844 16.1023 7.39844H14.4523C14.386 7.39844 14.3225 7.3721 14.2756 7.32521C14.2287 7.27833 14.2023 7.21474 14.2023 7.14844V6.64844C14.2023 6.58213 14.2287 6.51854 14.2756 6.47166C14.3225 6.42478 14.386 6.39844 14.4523 6.39844H16.1023C16.5002 6.39844 16.8817 6.55647 17.163 6.83778C17.4443 7.11908 17.6023 7.50061 17.6023 7.89844ZM17.3523 14.1984H16.8523C16.786 14.1984 16.7225 14.2248 16.6756 14.2717C16.6287 14.3185 16.6023 14.3821 16.6023 14.4484V16.0984C16.6023 16.231 16.5497 16.3582 16.4559 16.452C16.3621 16.5458 16.235 16.5984 16.1023 16.5984H14.4523C14.386 16.5984 14.3225 16.6248 14.2756 16.6717C14.2287 16.7185 14.2023 16.7821 14.2023 16.8484V17.3484C14.2023 17.4147 14.2287 17.4783 14.2756 17.5252C14.3225 17.5721 14.386 17.5984 14.4523 17.5984H16.1023C16.5002 17.5984 16.8817 17.4404 17.163 17.1591C17.4443 16.8778 17.6023 16.4963 17.6023 16.0984V14.4484C17.6023 14.3821 17.576 14.3185 17.5291 14.2717C17.4822 14.2248 17.4186 14.1984 17.3523 14.1984ZM9.55234 17.5984C9.61865 17.5984 9.68224 17.5721 9.72912 17.5252C9.776 17.4783 9.80234 17.4147 9.80234 17.3484V16.8484C9.80234 16.7821 9.776 16.7185 9.72912 16.6717C9.68224 16.6248 9.61865 16.5984 9.55234 16.5984H7.90234C7.76974 16.5984 7.64256 16.5458 7.54879 16.452C7.45502 16.3582 7.40234 16.231 7.40234 16.0984V14.4484C7.40234 14.3821 7.376 14.3185 7.32912 14.2717C7.28224 14.2248 7.21865 14.1984 7.15234 14.1984H6.65234C6.58604 14.1984 6.52245 14.2248 6.47557 14.2717C6.42868 14.3185 6.40234 14.3821 6.40234 14.4484V16.0984C6.40234 16.4963 6.56038 16.8778 6.84168 17.1591C7.12299 17.4404 7.50452 17.5984 7.90234 17.5984H9.55234ZM6.40234 7.89844V9.54844C6.40234 9.61474 6.42868 9.67833 6.47557 9.72521C6.52245 9.7721 6.58604 9.79844 6.65234 9.79844H7.15234C7.21865 9.79844 7.28224 9.7721 7.32912 9.72521C7.376 9.67833 7.40234 9.61474 7.40234 9.54844V7.89844C7.40234 7.76583 7.45502 7.63865 7.54879 7.54488C7.64256 7.45112 7.76974 7.39844 7.90234 7.39844H9.55234C9.61865 7.39844 9.68224 7.3721 9.72912 7.32521C9.776 7.27833 9.80234 7.21474 9.80234 7.14844V6.64844C9.80234 6.58213 9.776 6.51854 9.72912 6.47166C9.68224 6.42478 9.61865 6.39844 9.55234 6.39844H7.90234C7.50452 6.39844 7.12299 6.55647 6.84168 6.83778C6.56038 7.11908 6.40234 7.50061 6.40234 7.89844Z"
          fill="white"
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_16228_116835"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.95122 0.718561) rotate(45.8385) scale(32.4535 31.8926)"
        >
          <stop stopColor="#AD6CD6" />
          <stop offset="1" stopColor="#7B3BBB" />
        </radialGradient>
        <clipPath id="clip0_16228_116835">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
